module.exports = __webpack_public_path__ + "static/media/model1.27a9eafe.png";